import { FileText, Image as ImageIcon, Mic, Video, AlertTriangle } from "lucide-react";
import { StatusBadge } from "./StatusBadge";

const KIND_ICON = { pdf: FileText, image: ImageIcon, audio: Mic, video: Video };

export default function DocumentRow({ doc, onOpen }) {
  const Icon = KIND_ICON[doc.kind] || FileText;
  const c = doc.counts || {};
  const range = doc.date_range ? (doc.date_range.start === doc.date_range.end ? doc.date_range.start : `${doc.date_range.start} → ${doc.date_range.end}`) : null;
  return (
    <button
      onClick={() => onOpen(doc)}
      data-testid={`portal-doc-row-${doc.document_id}`}
      className="w-full text-left bg-gray-950 border border-white/5 hover:border-[#f59e0b]/40 rounded-xl px-4 py-3 flex items-start gap-3 transition-colors duration-200 group"
    >
      <Icon className="w-4 h-4 text-gray-500 group-hover:text-[#f59e0b] mt-0.5 shrink-0 transition-colors duration-200" />
      <div className="min-w-0 flex-1 space-y-1">
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-sm font-semibold text-white truncate max-w-full" data-testid={`portal-doc-name-${doc.document_id}`}>{doc.original_name}</span>
          <StatusBadge status={doc.status} testId={`portal-doc-status-${doc.document_id}`} />
          {doc.version > 1 && <span className="text-[9px] font-mono text-sky-300 border border-sky-500/30 rounded px-1">v{doc.version}</span>}
          {doc.classification?.uncertain && <span className="text-[9px] font-mono text-amber-300 flex items-center gap-0.5"><AlertTriangle className="w-3 h-3" /> uncertain type</span>}
        </div>
        <div className="flex flex-wrap gap-x-3 gap-y-0.5 text-[10px] font-mono text-gray-400">
          <span className="text-[#2dd4bf]">{doc.template_display || (doc.status === "processing" || doc.status === "pending" ? "classifying…" : "unclassified")}</span>
          {range && <span>{range}</span>}
          {c.events != null && <span>{c.events} events</span>}
          {!!c.ledger && <span>{c.ledger} ledger</span>}
          {!!c.deadlines && <span>{c.deadlines} deadlines</span>}
          {!!c.undated && <span>{c.undated} undated</span>}
          {!!c.discrepancies && <span className="text-rose-300">{c.discrepancies} flags</span>}
          {doc.duplicate_of && <span>duplicate of an existing upload</span>}
        </div>
        {doc.error && <div className="text-[11px] text-rose-300" data-testid={`portal-doc-error-${doc.document_id}`}>{doc.error}</div>}
      </div>
      <span className="text-[10px] font-mono text-gray-500 whitespace-nowrap hidden sm:block">{doc.upload_timestamp?.slice(0, 10)}</span>
    </button>
  );
}
